import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IconComponent } from '../icon';

export interface ActionCardData {
  title: string;
  description: string;
  icon: string;
  link: string;
  variant?: 'primary' | 'secondary';
}

@Component({
  selector: 'app-action-card',
  standalone: true,
  imports: [CommonModule, RouterModule, IconComponent],
  template: `
    <a
      [routerLink]="link"
      [ngClass]="{
        'bg-gradient-to-br from-[#4A90E2] to-[#2c5f8d] text-white':
          variant === 'primary',
        'bg-white border border-gray-200': variant !== 'primary'
      }"
      class="block rounded-lg p-6 hover:shadow-lg transition-shadow"
    >
      <app-icon
        [name]="icon"
        [className]="
          variant === 'primary'
            ? 'w-8 h-8 mb-3'
            : 'w-8 h-8 mb-3 text-[#4A90E2]'
        "
      ></app-icon>
      <h3
        [ngClass]="{
          'text-lg font-semibold mb-1': true,
          'text-white': variant === 'primary',
          'text-gray-900': variant !== 'primary'
        }"
      >
        {{ title }}
      </h3>
      <p
        [ngClass]="{
          'text-sm': true,
          'text-white/80': variant === 'primary',
          'text-gray-500': variant !== 'primary'
        }"
      >
        {{ description }}
      </p>
    </a>
  `,
})
export class ActionCardComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() icon: string = '';
  @Input() link: string = '';
  @Input() variant: 'primary' | 'secondary' = 'secondary';
}
